import { LoadableAfterPaint } from '@confluence/loadable';

import { PlaceholderPublishButton } from '../src/PlaceholderPublishButton.tsx';

export const PublishButtonWithMoreOptions = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-PublishButtonWithMoreOptions" */ '../src/PublishButtonWithMoreOptions.tsx'
			)
		).PublishButtonWithMoreOptions;
	},
	loading: PlaceholderPublishButton,
});
